import React, { useState } from 'react';
import { Form, useFormikContext } from 'formik';
import { SpacedFormLayout } from '../../../components/styled/forms';
import { ServicePlan } from '../../../types';
import { Section01ChildAndService } from './Section01ChildAndService';
import { Section02ServiceStatus } from './Section02ServiceStatus';
import { SectionOption03AsPlanned } from './SectionOption03AsPlanned';
import { SectionOption03WithChanges } from './SectionOption03WithChanges';
import { SectionOption03NotDelivered } from './SectionOption03NotDelivered';
import { Status } from '@cssat/acorn-service-delivery';
import { FormFields } from './validation';

export const TrackSessionForm: React.FC<{
  useStep: [number, React.Dispatch<React.SetStateAction<number>>];
}> = ({ useStep }) => {
  const useServicePlan = useState<ServicePlan>();
  const [step] = useStep;
  const { values } = useFormikContext<FormFields>();
  return (
    <Form>
      <SpacedFormLayout>
        {step === 1 && (
          <Section01ChildAndService useServicePlan={useServicePlan} />
        )}
        {(step === 2 || step === 3) && (
          <Section02ServiceStatus
            useServicePlan={useServicePlan}
            useStep={useStep}
          />
        )}
        <span data-testid="track-session-step-3">
          {step === 3 && values.serviceStatus === Status.AsPlanned && (
            <SectionOption03AsPlanned />
          )}
          {step === 3 && values.serviceStatus === Status.WithChanges && (
            <SectionOption03WithChanges useServicePlan={useServicePlan} />
          )}
          {step === 3 && values.serviceStatus === Status.NotDelivered && (
            <SectionOption03NotDelivered />
          )}
        </span>
      </SpacedFormLayout>
    </Form>
  );
};
